import type { FunctionComponent } from "react";

import { IdleQueue } from "scmp-app/components/common/idle-queue";
import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";

import { Container, StyledDynamicSubscriptionButton } from "./styles";

export type HeaderFeaturesSubscriptionProps = {
  isMagazineStyle?: boolean;
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesSubscription: FunctionComponent<HeaderFeaturesSubscriptionProps> = ({
  isMagazineStyle = false,
  shouldSwap,
  showIn,
  showOnSwap,
}) => (
  <IdleQueue>
    <Container $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledDynamicSubscriptionButton variant={isMagazineStyle ? "dark" : "light-blue"} />
    </Container>
  </IdleQueue>
);

HeaderFeaturesSubscription.displayName = "HeaderFeaturesSubscription";
